import { ELEMENT_ATTRIBUTE_GROUP, ELEMENT_GROUPS } from './../utils';

const SignupElementFields = {
  group: ELEMENT_GROUPS.AUTH,
  label: 'Signup',
  icon: 'UserAddIcon',
  description: 'Adds an email, password, and name elements',
  properties: [
    'fontFamily',
    {
      label: 'Post-Signup Action',
      name: 'action',
      editor: 'dropdown',
      default: '',
      description: 'An action to run when the user has successfully signed up',
      options: [],
      function: {
        name: 'getAppActions',
        params: ['app.id']
      },
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Signup Type',
      name: 'signupType',
      editor: 'dropdown',
      default: 'email',
      description: '',
      options: [
        {
          label: 'By Email',
          value: 'email'
        },
        {
          label: 'By Phone',
          value: 'phone'
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    'alignment',
    'margin',
    'padding',
    {
      label: 'Show Button Icon',
      name: 'showButtonIcon',
      editor: 'boolean',
      description: 'If the button should include an icon',
      group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
    },
    {
      label: 'Show Password',
      name: 'showPassword',
      editor: 'boolean',
      description: 'If the password field will not be masked',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Button Icon',
      name: 'buttonIcon',
      editor: 'icon',
      description: 'The button icon',
      displayWhen: [{ field: 'showButtonIcon', operator: '=', value: true }],
      group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
    },
    {
      name: 'buttonIconSize',
      label: 'Button Icon Size',
      description: '',
      editor: 'iconsize',
      type: 'number',
      default: 6,
      displayWhen: [{ field: 'showButtonIcon', operator: '=', value: true }],
      group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
    },
    {
      name: 'buttonText',
      label: 'Button Text',
      description: '',
      editor: 'textbox',
      type: 'string',
      default: 'Signup',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      name: 'userRole',
      label: 'User Role',
      description: 'The role to record against the new user record',
      editor: 'textbox',
      type: 'string',
      default: 'Signup',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Button Width',
      name: 'buttonWidth',
      editor: 'number',
      description: 'The width of the reset password button',
      default: 200,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Button Border Radius',
      name: 'buttonBorderRadius',
      editor: 'number',
      description: 'The border radius of the signup button',
      default: 4,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      name: 'buttonFont',
      label: 'Button Font',
      description: '',
      editor: 'fontsize',
      type: 'font',
      default: 14,
      group: ELEMENT_ATTRIBUTE_GROUP.FONTS
    },
    {
      name: 'buttonTextAlignment',
      label: 'Button Text Alignment',
      description: '',
      editor: 'alignment',
      type: 'string',
      default: 'justify-center',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      name: 'buttonPadding',
      label: 'Button Padding',
      description: '',
      editor: 'boundary',
      type: 'string',
      default: '15 10 15 10',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      name: 'buttonMargin',
      label: 'Button Margin',
      description: '',
      editor: 'boundary',
      type: 'string',
      default: '20 0 0 0',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },

    {
      name: 'buttonColor',
      label: 'Button Color',
      description: '',
      editor: 'color',
      type: 'string',
      default: '#ffffff',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      name: 'passwordHintColor',
      label: 'Password Hint Color',
      description: '',
      editor: 'color',
      type: 'string',
      default: '#ffffff',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      name: 'passwordHintFont',
      label: 'Password Hint Font',
      description: '',
      editor: 'fontsize',
      type: 'font',
      default: 14,
      group: ELEMENT_ATTRIBUTE_GROUP.FONTS
    },
    {
      name: 'buttonBackgroundColor',
      label: 'Button Background Color',
      description: '',
      editor: 'color',
      type: 'string',
      default: '#182fa4',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Show Already Registered Link',
      name: 'showAlreadyRegisteredLink',
      editor: 'boolean',
      default: true,
      description: 'Show the already registered link',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Already Registered Screen',
      name: 'alreadyRegisteredScreen',
      description: 'The destination screen for the already registered link',
      editor: 'dropdown',
      default: ' ',
      options: [],
      function: {
        name: 'getAppScreens',
        params: ['app.id']
      },
      displayWhen: [
        { field: 'showAlreadyRegisteredLink', operator: '=', value: true }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      name: 'alreadyRegisteredLinkText',
      label: 'Already Registered Text',
      description: 'The text for the already registered link',
      editor: 'textbox',
      type: 'string',
      default: 'Already Registered?',
      displayWhen: [
        { field: 'showAlreadyRegisteredLink', operator: '=', value: true }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Show Try a Different Method Link',
      name: 'showOtherMethodLink',
      editor: 'boolean',
      default: true,
      description: 'Enables a link for them to try a different signup method',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Try a Different Method Link Text',
      name: 'otherMethodLinkText',
      editor: 'textbox',
      default: 'Not Registered?',
      description: 'The text to display on the try a different method link',
      displayWhen: [
        { field: 'showOtherMethodLink', operator: '=', value: true }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Try a Different Link Screen',
      name: 'otherMethodScreen',
      description: 'The destination screen for the try a different method link',
      editor: 'dropdown',
      default: ' ',
      options: [],
      function: {
        name: 'getAppScreens',
        params: ['app.id']
      },
      displayWhen: [
        { field: 'showOtherMethodLink', operator: '=', value: true }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      name: 'alreadyRegisteredLinkColor',
      label: 'Already Registered Link Color',
      description: '',
      editor: 'color',
      type: 'string',
      default: '#ffffff',
      displayWhen: [
        { field: 'showAlreadyRegisteredLink', operator: '=', value: true }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      name: 'alreadyRegisteredLinkFont',
      label: 'Already Registered Link Font',
      description: '',
      editor: 'fontsize',
      type: 'font',
      default: 14,
      displayWhen: [
        { field: 'showAlreadyRegisteredLink', operator: '=', value: true }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.FONTS
    },
    {
      name: 'alreadyRegisteredLinkAlignment',
      label: 'Already Registered Link Alignment',
      description: '',
      editor: 'alignment',
      type: 'string',
      default: 'justify-center',
      displayWhen: [
        { field: 'showAlreadyRegisteredLink', operator: '=', value: true }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      name: 'alreadyRegisteredLinkMargin',
      label: 'Already Registered Link Margin',
      description: '',
      editor: 'boundary',
      type: 'string',
      default: '20 0 0 0',
      displayWhen: [
        { field: 'showAlreadyRegisteredLink', operator: '=', value: true }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Spinner Color',
      name: 'spinnerColor',
      editor: 'color',
      description:
        'The color of the activity indicator during signup processing.',
      default: '#182fa4',
      displayWhen: [],
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Spinner Size',
      name: 'spinnerSize',
      editor: 'dropdown',
      description: 'The size of the processing spinner.',
      default: 'small',
      options: [
        { label: 'Small', value: 'small' },
        { label: 'Large', value: 'large' }
      ],
      displayWhen: [],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    }
  ]
};

export default SignupElementFields;
